import { render, staticRenderFns } from "./CustomerAddress.vue?vue&type=template&id=cdc67d76&scoped=true"
import script from "./CustomerAddress.vue?vue&type=script&lang=ts"
export * from "./CustomerAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc67d76",
  null
  
)

export default component.exports